module.exports = __webpack_public_path__ + "img/Icon-08.e0a84796.png";